import Vue from "vue";
import Vuex from "vuex";
import createMultiTabState from "vuex-multi-tab-state";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    usuarioId: null,
    tipoUsuario: null,
    masterId:null,
    prospectoId: null,
    solicitudFisicaId: null,
    solicitudExtranjeraId: null,
    solicitudRepresentanteId: null,
    solicitudMoralId: null,
    prospectoRepresentanteLegalId: null,
    modoPago: null,
    telefonoprospecto: null,
    tipoPersona: null,
    sesionActiva: false,
    avisoPrivacidadAceptado: false,
    comprobantePagoEnviado: false,
    prospectoPadreFiguraAdicionalId:null,
    tipoFiguraAdicional:null,
    registroFiguraAdicional:false,
    crearProspecto:false,
    editarProspecto:false,
    etapaId: null,
    onboardingOnProgress: false,
    selectionDocument : null,
    currentDocument:{
      id:null,
      title:'',
      text:'',
      src_img:'',
      isVideo:'',
      src_video:'',
    },
    setCurrentDocument: '',
    isEditionResource : false,
    goToSinOnboarding : {to:''}
  },
  mutations: {
    setUsuario(state, usuarioId) {
      state.usuarioId = usuarioId;
    },
    setTipoUsuario(state, tipoUsuario) {
      state.tipoUsuario = tipoUsuario;
    },
    setMasterId(state, masterId) {
      state.masterId = masterId;
    },
    setProspecto(state, prospectoId) {
      state.prospectoId = prospectoId;
    },
    setSolicitudFisica(state, solicitudFisicaId) {
      state.solicitudFisicaId = solicitudFisicaId;
    },
    setSolicitudExtranjera(state, solicitudExtranjeraId) {
      state.solicitudExtranjeraId = solicitudExtranjeraId;
    },
    /*Personas moralaes y representantes legales*/
    setSolicitudMoral(state, solicitudMoralId) {
      state.solicitudMoralId = solicitudMoralId;
    },
    setProspectoRepresentanteLegal(state, prospectoRepresentanteLegalId) {
      state.prospectoRepresentanteLegalId = prospectoRepresentanteLegalId;
    },
    setSolicitudRepresentante(state, solicitudRepresentanteId) {
      state.solicitudRepresentanteId = solicitudRepresentanteId;
    },
    /*Tipo persona*/
    setTipoPersona(state, tipoPersona) {
      state.tipoPersona = tipoPersona;
    },
     /*Telefono prospecto*/
     setTelefonoProspecto(state, telefonoprospecto) {
      state.telefonoprospecto = telefonoprospecto;
    },
    /*Modo de pago */
    setModoPago(state, modoPago) {
      state.modoPago = modoPago;
    },
    setSesionActiva(state, sesionActiva) {
      state.sesionActiva = sesionActiva;
    },
    setAvisoPrivacidadAceptado(state, avisoPrivacidadAceptado) {
      state.avisoPrivacidadAceptado = avisoPrivacidadAceptado;
    },
    setCrearProspecto(state, crearProspecto) {
      state.crearProspecto = crearProspecto;
    },
    setEditarProspecto(state, editarProspecto) {
      state.editarProspecto = editarProspecto;
    },
    comprobantePagoEnviado(state, comprobantePagoEnviado) {
      state.comprobantePagoEnviado = comprobantePagoEnviado;
    },
    /*Registro de cotitulares o obligados solidarios*/
    setRegistroFiguraAdicional(state, registroFiguraAdicional) {
      state.registroFiguraAdicional = registroFiguraAdicional;
    },
    setProspectoPadreFiguraAdicionalId(state, prospectoPadreFiguraAdicionalId) {
      state.prospectoPadreFiguraAdicionalId = prospectoPadreFiguraAdicionalId;
    },
    setTipoFiguraAdicional(state, tipoFiguraAdicional) {
      state.tipoFiguraAdicional = tipoFiguraAdicional;
    },
    setEtapaId(state, etapaId) {
      state.etapaId = etapaId;
    },
    setOnboardingOnProgress(state, isOnOnboarding) {
      state.onboardingOnProgress = isOnOnboarding
    },
    
    setSelectionDocument(state, selection) {
      state.selectionDocument = selection
    },
    setCurrentDocument(state, currentDocument) {
      state.currentDocument = currentDocument
    },
    setCategoryName(state, categoryName) {
      state.categoryName = categoryName
    },
    setEditionResource(state, isEditionResource) {
      state.isEditionResource = isEditionResource
    },
    setGoToSinOnboarding(state, goToSinOnboarding) {
      state.goToSinOnboarding = goToSinOnboarding
    },

  },
  getters: {
    usuarioId: state => state.usuarioId,
    tipoUsuario: state => state.tipoUsuario,
    masterId: state => state.masterId,
    prospectoId: state => state.prospectoId,
    solicitudFisicaId: state => state.solicitudFisicaId,
    solicitudExtranjeraId: state => state.solicitudExtranjeraId,
    solicitudMoralId: state => state.solicitudMoralId,
    solicitudRepresentanteId: state => state.solicitudRepresentanteId,
    prospectoRepresentanteLegalId: state => state.prospectoRepresentanteLegalId,
    tipoPersona: state => state.tipoPersona,
    modoPago: state => state.modoPago,
    telefonoprospecto: state => state.telefonoprospecto,
    sesionActiva: state => state.sesionActiva,
    avisoPrivacidadAceptado: state => state.avisoPrivacidadAceptado,
    comprobantePagoEnviado: state => state.comprobantePagoEnviado,
    registroFiguraAdicional: state => state.registroFiguraAdicional,
    crearProspecto: state => state.crearProspecto,
    editarProspecto: state => state.editarProspecto,
    prospectoPadreFiguraAdicionalId: state => state.prospectoPadreFiguraAdicionalId,
    tipoFiguraAdicional: state => state.tipoFiguraAdicional,
    onboardingOnProgress: state => state.onboardingOnProgress,
    etapaId: state => state.etapaId,
    getseleccionDocument: state => state.selectionDocument,
    getCurrentDocument : state => state.currentDocument,
    getCategoryName : state => state.categoryName,
    getEditionResource : state => state.isEditionResource,
    getGoToSinOnboarding : state => state.goToSinOnboarding
  },
  plugins: [createMultiTabState()]
});